import { Ng2StateDeclaration } from '@uirouter/angular';
import { DashboardComponent } from '@client/app/pages/dashboard/dashboard.component';
import { SessionService } from '@monsido/core/session/session.service';
import {
    MonUIRouterTransitionService,
} from '@monsido/services/ui-router-transition-service/ui-router-transition-service';
import { StateService, Transition } from '@uirouter/core';
import { CoreError } from '@client/app/core/enums/core-error.enum';
import { LoginService } from '@client/app/core/services/login/login.service';

export const DASHBOARD_STATES: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.dashboard',
        url: '/?page&page_size&search&sort_by&sort_dir',
        views: {
            '$default@base.customer': {
                component: DashboardComponent,
            },
        },
        data: { anonymous_access: false, title: 'Acquia Web Governance - Dashboard' },
        params: {
            page: { dynamic: true },
            page_size: { dynamic: true },
            search: { dynamic: true },
            sort_by: { dynamic: true },
            sort_dir: { dynamic: true },
        },
        resolve: [
            {
                token: 'hasAccessToDomain',
                policy: { when: 'EAGER' },
                deps: [
                    SessionService,
                    StateService,
                    MonUIRouterTransitionService,
                    Transition,
                    LoginService,
                    'validateCustomer'],
                resolveFn: (
                    ng2SessionService: SessionService,
                    $state: StateService,
                    ng2MonUIRouterTransitionService: MonUIRouterTransitionService,
                    transition: Transition,
                    ng2CoreLoginService: LoginService,
                    validateCustomer,
                ) => {
                    if (ng2SessionService.customer) {
                        return Promise.resolve(true);
                    }
                    if (!ng2CoreLoginService.isLoggedIn()) {
                        // Abort the transition to prevent redundant API calls on entering further states
                        // User should be redirected to login page from the transition hook in basic.run
                        transition.abort();
                        return Promise.reject(new Error(CoreError.UserIsNotLoggedIn));
                    }

                    return ng2MonUIRouterTransitionService.onTransitionFinished(
                        () => {
                            $state.go('base.dashboard', transition.params());
                        },
                    );
                },
            },
        ],
    },
];
